import { useTranslation } from 'react-i18next';

import TrendUp from '../../../assets/icons/trend-up.svg';
import TrendDown from '../../../assets/icons/trend-down.svg';

function GrowthStat({ score }: { score: number }) {
  const { t } = useTranslation();

  return (
    <div className="mt-4 flex items-center gap-x-1 text-sm font-medium">
      {score === 0 ? (
        <span>{t('NO_CHANGE_SINCE_LAST_PERIOD')}</span>
      ) : (
        <>
          <img
            src={score >= 0 ? TrendUp : TrendDown}
            alt="trend-icon"
            className="h-3 w-3"
          />
          <span
            className={`font-figtree font-normal ${score >= 0 ? 'text-green-500' : 'text-red-500'}`}
          >
            {score}%
          </span>
          <span className="font-figtree font-normal">
            {t('VS_LAST_PERIOD')}
          </span>
        </>
      )}
    </div>
  );
}

export default GrowthStat;
